import { aliases, mdi } from 'vuetify/iconsets/mdi-svg'

export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.hook('vuetify:before-create', ({ vuetifyOptions }) => {
    vuetifyOptions.theme = {
      defaultTheme: 'default',
      themes: {
        default: {
          dark: false,
          colors: {
            'background': '#FFFFFF',
            'surface': '#FFFFFF',
            'surface-variant': '#424242',
            'on-surface-variant': '#EEEEEE',
            'primary': '#2d566b',
            'primary-darken-1': '#172d38',
            'secondary': '#617d3f',
            'secondary-darken-1': '#394925',
            'error': '#B00020',
            'info': '#2196F3',
            'success': '#4CAF50',
            'warning': '#FB8C00',
          },
        },
      },
    };

    vuetifyOptions.icons = {
      defaultSet: 'mdi',
      aliases,
      sets: {
        mdi,
      },
    };


  })
})
